// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let Question
import { getAPIURL } from "assessments/utils"
const Answer = require("assessments/models/answer").default

export default Question = (function () {
  Question = class Question extends (
    require("lib/static-shim").default(require("lib/utils/model").default)
  ) {
    static initClass() {
      this.prototype.types = [
        { name: "Multiple Choice", key: "multiple-choice", val: 1 },
        { name: "Paragraph", key: "paragraph", val: 2 }
      ]
    }

    url() {
      let url = `${this.get("assessment")}/question`
      if (this.id) {
        url = `${url}/${this.id}`
      }
      return getAPIURL(url, this)
    }

    initialize() {
      if (this.get("answer")) {
        this.answer = new Answer(this.get("answer"))
        this.answer.question = this
      }

      // TODO: move to admin
      return this.on("remove", this.onRemoveQuestion)
    }

    getAnswer(cb, forceReload) {
      if (forceReload == null) {
        forceReload = false
      }
      if (!this.answer || forceReload) {
        this.answer = new Answer({
          assessment: this.get("assessment"),
          question: this.id
        })
        return this.answer.fetch({
          success: (answer, response, options) => {
            return cb(answer)
          }
        })
      } else {
        return cb(this.answer)
      }
    }

    validateAnswer(answer) {
      let errors = []
      switch (this.get("assessment_question_type")) {
        case "1": // Multiple choice
          if (!answer.get("selected_option")) {
            errors = ["Please select an answer"]
          }
          break
        case "2": // Essay
          if (!answer.get("text_field")) {
            errors = ["Please enter an answer"]
          }
          break
      }
      return errors
    }

    validate(attrs) {
      if (!attrs) {
        attrs = this.attributes
      }
      if (attrs.skipValidation === true) {
        return
      }
      this.errors = []

      if (!attrs.title) {
        this.errors.push("Please enter a title for your question")
      }
      if (attrs.assessment_question_type === "1") {
        // multiple-choice

        // TODO: handle survey type (no answer required)
        if (attrs.options.length < 2) {
          this.errors.push("Please enter at least two options.")
        }

        const correctOps = _.filter(attrs.options, (op) => op.is_correct_answer)
        if (correctOps.length !== 1) {
          this.errors.push("Please select a correct answer.")
        }
      }

      if (this.errors.length) {
        return this.errors
      }
    }

    // Move all this to the admin!
    defaults() {
      const data = {
        assessment_question_type: "1", // multiple choice
        title: "",
        order: 0,
        options: [],
        skipValidation: false,
        help_text: ""
      }

      return data
    }

    getTypeKey() {
      const type = parseInt(this.get("assessment_question_type"))
      return __guard__(this.types[type - 1], (x) => x.key)
    }

    getQuestionType() {
      for (let type of Array.from(this.types)) {
        if (`${type.val}` === this.get("assessment_question_type")) {
          return type
        }
      }
      return null
    }

    getTypeChoices() {
      for (let type of Array.from(this.types)) {
        type.selected = `${type.val}` === this.get("assessment_question_type")
      }
      return this.types
    }

    getViewContext() {
      // TODO: move to the admin view!
      // returns the data needed to render templates
      const data = super.getViewContext()
      data.typeChoices = this.getTypeChoices()
      if (data.assessment_question_type === "1") {
        data.icon = "list"
      }
      if (data.assessment_question_type === "2") {
        data.icon = "quote-left"
      }
      return data
    }
  }
  Question.initClass()
  return Question
})()

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
